import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar, Typography } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import AddUsuarioComponents from "../../../../components/AddUsuarioComponents";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";



function AddUsuarioLocalPage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [nameUser, setNameUser] = useState('');
    const [apellidoUser, setApellidoUser] = useState('');
    const [emailUser, setEmailUser] = useState('');
    const [localSelected, setLocalSelected] = useState('');
    const [activo, setActivo] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const stateToken = useSelector(state => state.reducerGlobal.token);

    const params = useParams();

    const { id } = params;
    console.log("id", id);

    const navigate = useNavigate();



    useEffect(() => {
        if (id) {
            if (stateToken) {
                // handleDetalleEvento();
                setTimeout(() => {
                    setCargando(true);
                }, 1000);
            }
        } else {
            setTimeout(() => {
                setCargando(true);
            }, 1000);
        }
    }, [id, stateToken]);




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };

    //=========================================================funcion para guardar
    const handleGuardar = () => {
        let body = {};


        console.log("body", body);

        //validar campos que no esten vacios
        if (nameUser.trim() === '' || apellidoUser.trim() === '' || emailUser.trim() === '' || localSelected.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Todos los campos son obligatorios');
        } else {

            setLoadingGuardar(true);


            setTimeout(() => {
                setLoadingGuardar(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Guardado con exito');

                    setTimeout(() => {
                        navigate('/app/admin/paseo-plus-user-locales');
                    }, 1000);
                }, 1000);

            }, 2000);
        }
    };

    //=========================================================funcion para actualizar la contraseña
    const handleUpdatePassword = () => {
        if (newPassword.trim() === '' || confirmPassword.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Todos los campos son obligatorios');
        } else if (newPassword !== confirmPassword) {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Las contraseñas no coinciden');
        } else {
            setLoadingGuardar(true);

            setTimeout(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity('success');
                setMensaje('Contraseña actualizada con exito');
            }, 2000);
        }
    };

    //=============================================funcion para capturar el nombre del usuario
    const handleNamerUser = (e) => {
        setNameUser(e);
    };

    //=============================================funcion para capturar el apellido del usuario
    const handleApellidoUser = (e) => {
        setApellidoUser(e);
    };

    //=============================================funcion para capturar el email del usuario
    const handleEmailUser = (e) => {
        setEmailUser(e);
    };

    //=============================================funcion para capturar el local seleccionado
    const handleLocalSelected = (e) => {
        setLocalSelected(e);
    }







    return (
        <HeaderCustom>
            <div style={{
                marginTop: Padding.P2,
                padding: Padding.P2,
            }}>

                <div style={{
                    backgroundColor: PaletaColor.BLANCO,
                    borderRadius: Padding.P1,
                    padding: Padding.P3,
                }}>
                    {cargando ? (
                        <div style={{}}>
                            <Typography variant={'h5'} style={{ marginBottom: Padding.P2 }}>
                                Crear usuario para local
                            </Typography>

                            <AddUsuarioComponents
                                id={id}
                                handleCancelar={handleCancelar}
                                handleGuardar={handleGuardar}
                                handleUpdatePassword={handleUpdatePassword}

                                nameUser={nameUser}
                                handleNamerUser={handleNamerUser}

                                apellidoUser={apellidoUser}
                                handleApellidoUser={handleApellidoUser}

                                emailUser={emailUser}
                                handleEmailUser={handleEmailUser}

                                localSelected={localSelected}
                                handleLocalSelected={handleLocalSelected}

                                newPassword={newPassword}
                                setNewPassword={setNewPassword}

                                confirmPassword={confirmPassword}
                                setConfirmPassword={setConfirmPassword}

                                activo={activo}
                                setActivo={setActivo}

                            />
                        </div>
                    ) : <SkeletonLoading />
                    }
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddUsuarioLocalPage;